<template>
    <td class="whitespace-no-wrap" :class="{'px-6 py-4': !noPadding}">
        <slot/>
    </td>
</template>

<script>
export default {
    name: 'TableCell',

    props: {
        noPadding: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
